<template>
    <page-container class="role-manage"
                    v-loading="loaddingCurr"
                    element-loading-text="加载中..."
                    :class="{ 'content': !hideNavigate}">
        <el-breadcrumb slot="header"
                       separator="/"
                       v-if="!hideNavigate">
            <el-breadcrumb-item :to="{ path: '/home' }"
                                replace>电子印章</el-breadcrumb-item>
            <el-breadcrumb-item>
                <a>访问管理</a>
            </el-breadcrumb-item>
        </el-breadcrumb>

        <div class="manage-list">
            <div>
                <el-button class="grey-text small-font"
                           type="text"
                           v-if="!hideNavigate"
                           @click="$router.push('/home')">&lt; 返回上一页</el-button>
            </div>
            <manager 
                :info="adminInfo"
                :managerlist="sysmanagerlist"
                @delete="id => deleteManage(id, 'admin')"
                @add="configValue => addManage(configValue, 'admin')"
                ></manager>
            <manager 
                :info="ukeyInfo"
                :managerlist="ukeymanagerlist"
                @delete="id => deleteManage(id, 'ukey')"
                @add="configValue => addManage(configValue, 'ukey')"
                ></manager>
        </div>
        
    </page-container>
</template>
<script>
import PageContainer from "../../components/container.vue";
import Manager from './components/manager.vue';

export default {
    name: "Seal",
    components: { PageContainer, Manager },
    data () {
        return {
            sysmanagerlist: [],
            ukeymanagerlist: [],
            configValue: '',
            loaddingCurr: false,
            visible: false,
            adminInfo: {
                name: '系统管理员',
                desc: '对管理员以及访问签章平台权限进行管理',
                title: '证书序列号：',
            },
            ukeyInfo: {
                name: '访问限制',
                desc: '添加UKey通用实体唯一标识号后，被添加设备将无法登录系统',
                title: '通用实体唯一标识号：',
            },

        };
    },
    props: {
        hideNavigate: Boolean
    },
    computed: {
        quser () {
            return this.$store.getters.quser;
        },
    },
    created() {
        this.getSysmanagers('ukey');
        this.getSysmanagers('admin');
    },
    methods: {
        getSysmanagers(type) {
            let url = type === 'ukey' ? '/ukey/blacklist' : '/ukey/sysmanagerlist';
            this.axios({
                url,
                method: 'GET',
                params: {
                    companyId: this.quser.company.id
                }
            })
                .then(({ data }) => {
                    if (!data.code) {
                        if (type === 'ukey') {
                            this.ukeymanagerlist = data.result;
                        } else {
                            this.sysmanagerlist = data.result;
                        }
                    }
                });
        },
        deleteManage(id, type) {
            let url = type === 'ukey' ? '/ukey/blacklist/delete' : '/ukey/sysmanager/delete';
            this.axios({
                url,
                method: 'POST',
                transformRequest: [
                    function (data) {
                        let ret = '';
                        for (let it in data) {
                            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
                        }
                        return ret;
                    }
                ],
                data: { id }
            })
                .then(({ data }) => {
                    if (!data.code) {
                        this.$message.success('删除成功');
                        this.getSysmanagers(type);
                    } else {
                        this.$message.error(data.message);
                    }
                });
        },
        addManage(configValue, type) {
            let url = type === 'ukey' ? '/ukey/blacklist/add' : '/ukey/sysmanager/add';
            this.axios({
                url,
                method: 'POST',
                data: { configValue },
                transformRequest: [
                    function (data) {
                        let ret = '';
                        for (let it in data) {
                            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
                        }
                        return ret;
                    }
                ],
            })
                .then(({ data }) => {
                    if (!data.code) {
                        this.$message.success('添加成功');
                        this.getSysmanagers(type);
                        this.visible = false;
                        this.configValue = '';
                    } else {
                        this.$message.error(data.message);
                    }
                });
        },
    },
    beforeDestroy () {
        clearInterval(this.timer);
    }
};
</script>
<style lang="less" scoped>
.role-manage {
    padding: 15px;

    .manage-list {
        padding: 20px;
        margin: 0 auto;
        .el-button--default {
            border: 1px solid @red;
            margin-bottom: 20px;
            color: @red;
        }
    }

    .role {
        .role-name {
            font-size: 16px;
            font-weight: 600;
        }
        .desc {
            margin-top: 6px;
            color: #999;
        }
        .serial-num {
            font-size: 14px;
            margin-top: 16px;

            .add-button {
                padding: 2px;
            }

            /deep/.el-tag {
                margin-right: 10px;
            }

            .serial-title {
                font-size: 14px;
                font-weight: 600;
            }
        }
    }
    
}
</style>